import gql from "graphql-tag";

export const deleteExpert = gql`
  mutation deleteExpert($id: ID!) {
    deleteUser (where: { id: $id }) {
      id
    }
  }
`;
